const API_URL = process.env.REACT_APP_API_URL;

export const fetchItems = (item) => {
  // If an item argument is provided, fetch a specific item by item_id
  if (item) {
    return fetch(`${API_URL}/item-by-id?item_id=${item}`, { credentials: 'include' })
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) return data;
        if (data && typeof data === 'object' && Object.keys(data).length === 0) return [];
        return data ? data : [];
      })
      .catch(error => {
        console.error('Error fetching product:', error);
        throw error;
      });
  }
  return fetch(`${API_URL}/item-by-id`, { credentials: 'include' })
    .then(res => res.json())
    .then(data => {
      if (Array.isArray(data)) return data;
      if (data && typeof data === 'object' && Object.keys(data).length === 0) return [];
      return data ? data : [];
    })
    .catch(error => {
      console.error('Error fetching products:', error);
      throw error; // Re-throw the error to handle it in the component
    });
};

export const fetchInventory = () => {
  return fetch(`${API_URL}/inventory`, { credentials: 'include' })
    .then(res => res.json())
    .catch(error => {
      console.error('Error fetching products:', error);
      throw error; // Re-throw the error to handle it in the component
    });
};

export const fetchLocations = () => {
  return fetch(`${API_URL}/location`, { credentials: 'include' })
    .then(res => res.json())
    .catch(error => {
      console.error('Error fetching locations:', error);
      throw error; // Re-throw the error to handle it in the component
    });
}

export const fetchCompartments = (squadronId) => {
  return fetch(`${API_URL}/compartment?squadron_id=${squadronId}`, { credentials: 'include' })
    .then(res => res.json())
    .catch(error => {
      console.error('Error fetching compartments:', error);
      throw error; // Re-throw the error to handle it in the component
    });
}

// New: auth helpers moved here so components don't call fetch directly
export const fetchCurrentUser = async () => {
  try {
    const res = await fetch(`${API_URL}/me`, { credentials: 'include' });
    if (!res.ok) {
      // not authenticated or other non-OK response
      throw new Error(`Status ${res.status}`);
    }
    return await res.json();
  } catch (error) {
    console.error('Error fetching current user:', error);
    throw error;
  }
};

export const logout = async () => {
  try {
    await fetch(`${API_URL}/logout`, { method: 'GET', credentials: 'include' });
  } catch (error) {
    console.error('Error during logout:', error);
    // still allow caller to proceed (component may choose to ignore)
    throw error;
  }
};

export const getLoginUrl = () => `${API_URL}/login`;

// New API helpers -> move all ad-hoc fetch usage into centralized functions

export const createItems = async (itemsArray = []) => {
  const res = await fetch(`${API_URL}/item`, {
    method: 'POST',
    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(itemsArray)
  });
  if (!res.ok) {
    const txt = await res.text().catch(()=> '');
    throw new Error(`createItems failed: ${res.status} ${txt}`);
  }
  return res.json().catch(()=>null);
};

export const deleteItem = async (itemId) => {
  const res = await fetch(`${API_URL}/item?item_id=${itemId}`, {
    method: 'DELETE',
    headers: { 'Accept': 'application/json' },
    credentials: 'include'
  });
  if (!res.ok) {
    const txt = await res.text().catch(()=> '');
    throw new Error(`deleteItem failed: ${res.status} ${txt}`);
  }
  return true;
};

export const addInventory = async (inventoryArray = []) => {
  const res = await fetch(`${API_URL}/inventory/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(inventoryArray)
  });
  if (!res.ok) {
    const txt = await res.text().catch(()=> '');
    throw new Error(`addInventory failed: ${res.status} ${txt}`);
  }
  return res.json().catch(()=>null);
};

export const deleteInventory = async (itemIds = []) => {
  const res = await fetch(`${API_URL}/inventory`, {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ item_ids: itemIds })
  });
  if (!res.ok) {
    const txt = await res.text().catch(()=> '');
    throw new Error(`deleteInventory failed: ${res.status} ${txt}`);
  }
  return true;
};

export const transferInventory = async (inventoryArray = [], squadron_id, compartment_id) => {
  const res = await fetch(`${API_URL}/inventory/transfer`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(
    {
      "item_ids": inventoryArray,
      "to_location": squadron_id,
      "to_compartment": compartment_id
    })
  });
  if (!res.ok) {
    const txt = await res.text().catch(()=> '');
    throw new Error(`addInventory failed: ${res.status} ${txt}`);
  }
  return res.json().catch(()=>null);
}

// NSN endpoints
export const addNsns = async (nsnArray = []) => {
  const res = await fetch(`${API_URL}/item/nsn`, {
    method: 'POST',
    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(nsnArray)
  });
  if (!res.ok) {
    const txt = await res.text().catch(()=> '');
    throw new Error(`addNsns failed: ${res.status} ${txt}`);
  }
  return res.json().catch(()=>null);
};

export const updateNsn = async (nsnId, body = {}) => {
  const res = await fetch(`${API_URL}/item/nsn?nsn_id=${nsnId}`, {
    method: 'PUT',
    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(body)
  });
  if (!res.ok) {
    const txt = await res.text().catch(()=> '');
    throw new Error(`updateNsn failed: ${res.status} ${txt}`);
  }
  return res.json().catch(()=>null);
};

export const deleteNsn = async (nsnId) => {
  const res = await fetch(`${API_URL}/item/nsn?nsn_id=${nsnId}`, {
    method: 'DELETE',
    credentials: 'include'
  });
  if (!res.ok) {
    const txt = await res.text().catch(()=> '');
    throw new Error(`deleteNsn failed: ${res.status} ${txt}`);
  }
  return true;
};

// New: unassociate CAPID from current user
export const unassociateCapid = async () => {
  const res = await fetch(`${API_URL}/unassociate_capid`, {
    method: 'POST',
    headers: { 'Accept': 'application/json' },
    credentials: 'include'
  });
  if (!res.ok) {
    const txt = await res.text().catch(()=> '');
    throw new Error(`unassociateCapid failed: ${res.status} ${txt}`);
  }
  // some endpoints may return an empty body; tolerate that
  return res.json().catch(()=>null);
};

// New: associate a CAPID for current user
export const associateCapid = async (capid) => {
  const res = await fetch(`${API_URL}/associate_capid?capid=${encodeURIComponent(capid)}`, {
    method: 'POST',
    headers: { 'Accept': 'application/json' },
    credentials: 'include'
  });
  if (!res.ok) {
    const txt = await res.text().catch(()=> '');
    throw new Error(`associateCapid failed: ${res.status} ${txt}`);
  }
  return res.json().catch(()=>null);
};